import { render, staticRenderFns } from "./InvestmentMetadata.vue?vue&type=template&id=c36bf11c"
import script from "./InvestmentMetadata.vue?vue&type=script&lang=js"
export * from "./InvestmentMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports